/** Zona 2 (tela L-02): sumário, com o deny-by-default visível.
 *
 * Seção não liberada aparece — o aluno precisa saber que o material existe —,
 * mas não navega. O cadeado é decorativo: quem usa leitor de tela recebe a
 * informação por `aria-disabled` e pelo texto, não pelo emoji.
 */
import { useReaderStore } from '@/features/reader/stores/readerStore'
import { flattenToc, isSectionReleased, sectionForPage } from '@/features/reader/utils/toc'
import type { BookAccess } from '@/types/api'

interface SidebarProps {
  access: BookAccess
  /** No mobile a sidebar vira drawer e precisa se fechar ao navegar (L-08). */
  comoDrawer?: boolean
}

export function Sidebar({ access, comoDrawer = false }: SidebarProps) {
  const page = useReaderStore((s) => s.page)
  const irParaPagina = useReaderStore((s) => s.irParaPagina)
  const alternarSidebar = useReaderStore((s) => s.alternarSidebar)

  const secoes = flattenToc(access.toc)
  const secaoAtual = sectionForPage(access.toc, page)

  if (secoes.length === 0) {
    return (
      <nav id="reader-sidebar" className="reader-sidebar" aria-label="Sumário">
        <h2>Sumário</h2>
        <p className="reader-sidebar__vazio">Este material não tem sumário.</p>
      </nav>
    )
  }

  return (
    <nav id="reader-sidebar" className="reader-sidebar" aria-label="Sumário">
      <h2>Sumário</h2>
      <ul>
        {secoes.map((secao) => {
          const liberada = isSectionReleased(access, secao)
          const ativa = secaoAtual?.locator === secao.locator
          return (
            <li key={secao.locator}>
              <button
                type="button"
                onClick={() => {
                  irParaPagina(secao.page_start, access.page_count ?? undefined)
                  if (comoDrawer) alternarSidebar()
                }}
                disabled={!liberada}
                aria-disabled={!liberada}
                aria-current={ativa ? 'page' : undefined}
              >
                <span className="reader-sidebar__titulo">{secao.title}</span>
                {!liberada && (
                  <span className="reader-sidebar__bloqueada">
                    <span aria-hidden="true">🔒 </span>
                    ainda não liberado
                  </span>
                )}
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
